import { Link } from "react-router-dom";
import { trackOutboundLink } from "./analytics";

export default function NavBar() {
  return (
    <nav className="bg-black border-black dark:bg-black dark:black overflow-visible relative z-50">
      <div className="block w-full md:hidden">
        <ul className="flex flex-row font-medium p-4 justify-center space-x-6">
          <li>
            <Link to="/aboutus" className="text-sm text-gray-200 hover:text-blue-200 didact-gothic-regular tracking-widest">ABOUT</Link>
          </li>
          <li>
            <a href="/#journey" className="text-sm text-gray-200 hover:text-blue-200 didact-gothic-regular tracking-widest">JOURNEY</a>
          </li>
          <li>
            <a
              href="https://oceanbeachbrands.myshopify.com"
              onClick={() => trackOutboundLink("https://oceanbeachbrands.myshopify.com", "Mobile nav shop", { navigation_location: "mobile_header" })}
              className="text-sm text-gray-200 hover:text-blue-200 didact-gothic-regular tracking-widest"
            >
              SHOP
            </a>
          </li>
        </ul>
      </div>

      {/* Mobile Logo Section - Centered Row with more breathing room */}
      <div className="flex md:hidden items-center justify-center gap-4 pb-8 pt-2 px-6">
        <Link to="/">
          <img
            className="h-14 object-contain"
            src={require("./pictures/zeronimo-logo-optimized.webp")}
            alt="Zeronimo Logo"
          />
        </Link>
        <div className="flex flex-col items-start">
          <span className="text-gray-500 text-[7px] tracking-[0.2em] uppercase font-bold whitespace-nowrap mb-1">
            Brought to you by
          </span>
          <a
            href="https://oceanbeachcafe.com"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-opacity hover:opacity-100"
            onClick={() => trackOutboundLink("https://oceanbeachcafe.com", "Mobile Ocean Beach Cafe logo", { navigation_location: "mobile_header" })}
          >
            <img
              className="h-10 opacity-80"
              src={require("./pictures/obc-logo-optimized.webp")}
              alt="Ocean Beach Cafe Logo"
            />
          </a>
        </div>
      </div>

      <div className="hidden md:flex max-w-screen-xl items-center justify-between mx-auto px-12 py-6 relative h-32">
        <Link to="/" className="flex items-center">
          <img
            className="h-28 lg:h-32 object-contain"
            src={require("./pictures/zeronimo-logo-optimized.webp")}
            alt="Zeronimo Premium Non-Alcoholic Wine Logo"
          />
        </Link>

        <div className="flex items-center flex-1 justify-center px-12">
          <ul className="flex flex-row font-medium space-x-16">
            <li>
              <Link to="/aboutus" className="text-xs lg:text-sm text-gray-300 hover:text-white transition-colors didact-gothic-regular tracking-[0.3em] uppercase">About</Link>
            </li>
            <li>
              <a href="/#journey" className="text-xs lg:text-sm text-gray-300 hover:text-white transition-colors didact-gothic-regular tracking-[0.3em] uppercase">Journey</a>
            </li>
            <li>
              <a
                href="https://oceanbeachbrands.myshopify.com"
                onClick={() => trackOutboundLink("https://oceanbeachbrands.myshopify.com", "Desktop nav shop", { navigation_location: "desktop_header" })}
                className="text-xs lg:text-sm text-gray-300 hover:text-white transition-colors didact-gothic-regular tracking-[0.3em] uppercase"
              >
                Shop
              </a>
            </li>
          </ul>
        </div>

        <div className="flex items-center gap-4">
          <span className="text-gray-500 text-[9px] tracking-[0.2em] uppercase font-bold whitespace-nowrap">
            Brought to you by
          </span>
          <a
            href="https://oceanbeachcafe.com"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-opacity hover:opacity-100 block"
            onClick={() => trackOutboundLink("https://oceanbeachcafe.com", "Desktop Ocean Beach Cafe logo", { navigation_location: "desktop_header" })}
          >
            <img
              className="h-16 lg:h-20 opacity-70 hover:opacity-100 transition-all duration-500 brightness-110"
              src={require("./pictures/obc-logo-optimized.webp")}
              alt="Ocean Beach Cafe Logo"
            />
          </a>
        </div>
      </div>
    </nav>
  );
}
